module.exports = __webpack_public_path__ + "static/media/cebolla.72a18ec7.png";